module.exports = __webpack_public_path__ + "static/media/facts.fa1b7a18.png";